'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import DetailedTermSelector from 'pricing-pages-unified-ui/components/common/DetailedTermSelector';
import { currentSkuIdForProductSelector } from '../../selectors/ProductsSelectors';
import { crmSuiteAvailableTermsSelector } from '../../selectors/OfferSelectors';
import Whitespace from '../common/Whitespace';
import { useContext } from 'react';
import { IsMobileContext } from './CrmSuiteTopSection/SuiteTiles';
import { CRM_SUITE_PRODUCTS } from 'pricing-pages-lib/utils/productsUtils';
import styled from 'styled-components';
const StyledTermSelectorContainer = styled(DetailedTermSelector).withConfig({
  displayName: "SuiteTermSelectorContainer__StyledTermSelectorContainer",
  componentId: "sc-1xirma4-0"
})(["max-width:300px;margin:0 auto;"]);

const SuiteTermSelectorContainer = ({
  queryParamTerm,
  productLevel,
  onChange,
  trackingSource
}) => {
  const isMobile = useContext(IsMobileContext);
  const skuIds = useSelector(reduxState => {
    return CRM_SUITE_PRODUCTS[productLevel].map(productLine => {
      return currentSkuIdForProductSelector(reduxState, {
        productLine,
        productLevel
      });
    });
  });
  const hasMultipleTerms = useSelector(reduxState => crmSuiteAvailableTermsSelector(reduxState, {
    productLevel
  })).length > 1;

  if (!hasMultipleTerms) {
    return /*#__PURE__*/_jsx(Whitespace, {
      height: isMobile ? 20 : 41
    });
  }

  return /*#__PURE__*/_jsx(StyledTermSelectorContainer, {
    skuIds: skuIds,
    onChange: onChange,
    trackingSource: `${trackingSource}-${productLevel.toLowerCase()}`,
    activeTerm: queryParamTerm
  });
};

export default SuiteTermSelectorContainer;